(function () {
  const POINTS_PER_REWARD = 100;
  const REWARD_VALUE = 20;
  const CIRCUMFERENCE = 2 * Math.PI * 18; // 113.1

  function updateWidget(points) {
    const widget = document.getElementById('smile-points-widget');
    if (!widget) return;

    widget.style.display = 'flex';

    document.getElementById('smile-points-number').textContent = points;

    const progress = (points % POINTS_PER_REWARD) / POINTS_PER_REWARD;
    const offset = CIRCUMFERENCE - (progress * CIRCUMFERENCE);
    const ring = document.getElementById('smile-progress-ring');
    if (ring) ring.style.strokeDashoffset = offset;

    const pointsToNext = POINTS_PER_REWARD - (points % POINTS_PER_REWARD);
    const meta = document.getElementById('smile-points-to-next');
    if (meta) {
      meta.textContent = pointsToNext === POINTS_PER_REWARD
        ? '£' + REWARD_VALUE + ' ready!'
        : pointsToNext + ' pts to £' + REWARD_VALUE;
    }

    widget.addEventListener('click', function () {
      if (typeof SmileUI !== 'undefined') SmileUI.openPanel();
    });
  }

  function initWidget() {
    SmileUI.customerReady().then(function (customer) {
      if (customer && customer.points_balance !== undefined) {
        updateWidget(customer.points_balance);
      }
    }).catch(function (err) {
      console.warn('[SmileWidget] customerReady failed:', err);
    });
  }

  // Increased attempts to 80 (20 seconds) and added DOMContentLoaded fallback
  function startPolling() {
    let attempts = 0;
    const poll = setInterval(function () {
      if (typeof SmileUI !== 'undefined' && typeof SmileUI.customerReady === 'function') {
        clearInterval(poll);
        initWidget();
      }
      if (++attempts > 80) {
        clearInterval(poll);
        console.warn('[SmileWidget] SmileUI not available after 20s');
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startPolling);
  } else {
    startPolling();
  }
})();
